import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CoverEditor } from '../components/CoverEditor';

export function TaskingBotBookCoverEditor() {
  const [params] = useSearchParams();
  const bookId = params.get('bookId') || '';
  if (!bookId) {
    return (
      <div style={{ padding: 32, color: '#999' }}>
        <h2>Book Cover Editor</h2>
        <p>Missing <code>?bookId=…</code> in the URL.</p>
      </div>
    );
  }
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <CoverEditor bookId={bookId} />
    </div>
  );
}

export default TaskingBotBookCoverEditor;
